export const ALERT_NOTES_REPORT_DEFAULT_SORT = {
  sortedColumn: 'createdAt',
  sortedColumnOrder: 'descend'
}
